// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/watchlist_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Ticker } from "./ticker_service_pb";
import { file_api_v1_ticker_service } from "./ticker_service_pb";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/watchlist_service.proto.
 */
export const file_api_v1_watchlist_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_v1_ticker_service, file_google_protobuf_field_mask]);

/**
 * Watchlist represents a user-defined ticker category
 *
 * @generated from message journal.api.v1.Watchlist
 */
export type Watchlist = Message<"journal.api.v1.Watchlist"> & {
  /**
   * Watchlist ID (UUID)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Creator user ID (UUID)
   *
   * @generated from field: string creator_id = 2;
   */
  creatorId: string;

  /**
   * Watchlist name (max 50 chars)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Creation timestamp (Unix)
   *
   * @generated from field: int64 created_at = 4;
   */
  createdAt: bigint;

  /**
   * Last update timestamp (Unix)
   *
   * @generated from field: int64 updated_at = 5;
   */
  updatedAt: bigint;

  /**
   * Number of tickers in this watchlist
   *
   * @generated from field: int32 ticker_count = 6;
   */
  tickerCount: number;
};

/**
 * Describes the message journal.api.v1.Watchlist.
 * Use `create(WatchlistSchema)` to create a new message.
 */
export const WatchlistSchema: GenMessage<Watchlist> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 0);

/**
 * CreateWatchlistRequest creates a new watchlist
 *
 * @generated from message journal.api.v1.CreateWatchlistRequest
 */
export type CreateWatchlistRequest = Message<"journal.api.v1.CreateWatchlistRequest"> & {
  /**
   * Watchlist to create (only name is required)
   *
   * @generated from field: journal.api.v1.Watchlist watchlist = 1;
   */
  watchlist?: Watchlist;
};

/**
 * Describes the message journal.api.v1.CreateWatchlistRequest.
 * Use `create(CreateWatchlistRequestSchema)` to create a new message.
 */
export const CreateWatchlistRequestSchema: GenMessage<CreateWatchlistRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 1);

/**
 * CreateWatchlistResponse returns the created watchlist
 *
 * @generated from message journal.api.v1.CreateWatchlistResponse
 */
export type CreateWatchlistResponse = Message<"journal.api.v1.CreateWatchlistResponse"> & {
  /**
   * Created watchlist with ID
   *
   * @generated from field: journal.api.v1.Watchlist watchlist = 1;
   */
  watchlist?: Watchlist;
};

/**
 * Describes the message journal.api.v1.CreateWatchlistResponse.
 * Use `create(CreateWatchlistResponseSchema)` to create a new message.
 */
export const CreateWatchlistResponseSchema: GenMessage<CreateWatchlistResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 2);

/**
 * ListWatchlistsRequest lists watchlists for the current user
 *
 * Optional filters (future use)
 *
 * @generated from message journal.api.v1.ListWatchlistsRequest
 */
export type ListWatchlistsRequest = Message<"journal.api.v1.ListWatchlistsRequest"> & {
};

/**
 * Describes the message journal.api.v1.ListWatchlistsRequest.
 * Use `create(ListWatchlistsRequestSchema)` to create a new message.
 */
export const ListWatchlistsRequestSchema: GenMessage<ListWatchlistsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 3);

/**
 * ListWatchlistsResponse returns the list of watchlists
 *
 * @generated from message journal.api.v1.ListWatchlistsResponse
 */
export type ListWatchlistsResponse = Message<"journal.api.v1.ListWatchlistsResponse"> & {
  /**
   * List of watchlists
   *
   * @generated from field: repeated journal.api.v1.Watchlist watchlists = 1;
   */
  watchlists: Watchlist[];
};

/**
 * Describes the message journal.api.v1.ListWatchlistsResponse.
 * Use `create(ListWatchlistsResponseSchema)` to create a new message.
 */
export const ListWatchlistsResponseSchema: GenMessage<ListWatchlistsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 4);

/**
 * UpdateWatchlistRequest updates a watchlist
 *
 * @generated from message journal.api.v1.UpdateWatchlistRequest
 */
export type UpdateWatchlistRequest = Message<"journal.api.v1.UpdateWatchlistRequest"> & {
  /**
   * Watchlist resource name (format: "watchlists/{id}")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * New name for the watchlist
   *
   * @generated from field: string new_name = 2;
   */
  newName: string;

  /**
   * Fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateWatchlistRequest.
 * Use `create(UpdateWatchlistRequestSchema)` to create a new message.
 */
export const UpdateWatchlistRequestSchema: GenMessage<UpdateWatchlistRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 5);

/**
 * UpdateWatchlistResponse returns the updated watchlist
 *
 * @generated from message journal.api.v1.UpdateWatchlistResponse
 */
export type UpdateWatchlistResponse = Message<"journal.api.v1.UpdateWatchlistResponse"> & {
  /**
   * Updated watchlist
   *
   * @generated from field: journal.api.v1.Watchlist watchlist = 1;
   */
  watchlist?: Watchlist;
};

/**
 * Describes the message journal.api.v1.UpdateWatchlistResponse.
 * Use `create(UpdateWatchlistResponseSchema)` to create a new message.
 */
export const UpdateWatchlistResponseSchema: GenMessage<UpdateWatchlistResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 6);

/**
 * DeleteWatchlistRequest deletes a watchlist
 *
 * @generated from message journal.api.v1.DeleteWatchlistRequest
 */
export type DeleteWatchlistRequest = Message<"journal.api.v1.DeleteWatchlistRequest"> & {
  /**
   * Watchlist resource name (format: "watchlists/{id}")
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteWatchlistRequest.
 * Use `create(DeleteWatchlistRequestSchema)` to create a new message.
 */
export const DeleteWatchlistRequestSchema: GenMessage<DeleteWatchlistRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 7);

/**
 * DeleteWatchlistResponse confirms deletion
 *
 * @generated from message journal.api.v1.DeleteWatchlistResponse
 */
export type DeleteWatchlistResponse = Message<"journal.api.v1.DeleteWatchlistResponse"> & {
};

/**
 * Describes the message journal.api.v1.DeleteWatchlistResponse.
 * Use `create(DeleteWatchlistResponseSchema)` to create a new message.
 */
export const DeleteWatchlistResponseSchema: GenMessage<DeleteWatchlistResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 8);

/**
 * AddSymbolToWatchlistRequest adds a ticker by symbol to a watchlist
 *
 * @generated from message journal.api.v1.AddSymbolToWatchlistRequest
 */
export type AddSymbolToWatchlistRequest = Message<"journal.api.v1.AddSymbolToWatchlistRequest"> & {
  /**
   * Watchlist ID (UUID)
   *
   * @generated from field: string watchlist_id = 1;
   */
  watchlistId: string;

  /**
   * Ticker symbol (e.g., "AAPL")
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;
};

/**
 * Describes the message journal.api.v1.AddSymbolToWatchlistRequest.
 * Use `create(AddSymbolToWatchlistRequestSchema)` to create a new message.
 */
export const AddSymbolToWatchlistRequestSchema: GenMessage<AddSymbolToWatchlistRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 9);

/**
 * AddSymbolToWatchlistResponse returns the ticker
 *
 * @generated from message journal.api.v1.AddSymbolToWatchlistResponse
 */
export type AddSymbolToWatchlistResponse = Message<"journal.api.v1.AddSymbolToWatchlistResponse"> & {
  /**
   * Created or existing ticker
   *
   * @generated from field: journal.api.v1.Ticker ticker = 1;
   */
  ticker?: Ticker;
};

/**
 * Describes the message journal.api.v1.AddSymbolToWatchlistResponse.
 * Use `create(AddSymbolToWatchlistResponseSchema)` to create a new message.
 */
export const AddSymbolToWatchlistResponseSchema: GenMessage<AddSymbolToWatchlistResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 10);

/**
 * RemoveTickerFromWatchlistRequest removes a ticker from a watchlist
 *
 * @generated from message journal.api.v1.RemoveTickerFromWatchlistRequest
 */
export type RemoveTickerFromWatchlistRequest = Message<"journal.api.v1.RemoveTickerFromWatchlistRequest"> & {
  /**
   * Watchlist ID (UUID)
   *
   * @generated from field: string watchlist_id = 1;
   */
  watchlistId: string;

  /**
   * Ticker ID (UUID)
   *
   * @generated from field: string ticker_id = 2;
   */
  tickerId: string;
};

/**
 * Describes the message journal.api.v1.RemoveTickerFromWatchlistRequest.
 * Use `create(RemoveTickerFromWatchlistRequestSchema)` to create a new message.
 */
export const RemoveTickerFromWatchlistRequestSchema: GenMessage<RemoveTickerFromWatchlistRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 11);

/**
 * RemoveTickerFromWatchlistResponse confirms removal
 *
 * @generated from message journal.api.v1.RemoveTickerFromWatchlistResponse
 */
export type RemoveTickerFromWatchlistResponse = Message<"journal.api.v1.RemoveTickerFromWatchlistResponse"> & {
};

/**
 * Describes the message journal.api.v1.RemoveTickerFromWatchlistResponse.
 * Use `create(RemoveTickerFromWatchlistResponseSchema)` to create a new message.
 */
export const RemoveTickerFromWatchlistResponseSchema: GenMessage<RemoveTickerFromWatchlistResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_watchlist_service, 12);

/**
 * WatchlistService manages user-defined watchlists for categorizing tickers
 *
 * @generated from service journal.api.v1.WatchlistService
 */
export const WatchlistService: GenService<{
  /**
   * CreateWatchlist creates a new watchlist
   *
   * @generated from rpc journal.api.v1.WatchlistService.CreateWatchlist
   */
  createWatchlist: {
    methodKind: "unary";
    input: typeof CreateWatchlistRequestSchema;
    output: typeof CreateWatchlistResponseSchema;
  },
  /**
   * ListWatchlists lists all watchlists for the current user
   *
   * @generated from rpc journal.api.v1.WatchlistService.ListWatchlists
   */
  listWatchlists: {
    methodKind: "unary";
    input: typeof ListWatchlistsRequestSchema;
    output: typeof ListWatchlistsResponseSchema;
  },
  /**
   * UpdateWatchlist updates an existing watchlist (e.g., rename)
   *
   * @generated from rpc journal.api.v1.WatchlistService.UpdateWatchlist
   */
  updateWatchlist: {
    methodKind: "unary";
    input: typeof UpdateWatchlistRequestSchema;
    output: typeof UpdateWatchlistResponseSchema;
  },
  /**
   * DeleteWatchlist deletes a watchlist
   *
   * @generated from rpc journal.api.v1.WatchlistService.DeleteWatchlist
   */
  deleteWatchlist: {
    methodKind: "unary";
    input: typeof DeleteWatchlistRequestSchema;
    output: typeof DeleteWatchlistResponseSchema;
  },
  /**
   * AddSymbolToWatchlist adds a ticker by symbol to a watchlist (auto-creates ticker if not exists)
   *
   * @generated from rpc journal.api.v1.WatchlistService.AddSymbolToWatchlist
   */
  addSymbolToWatchlist: {
    methodKind: "unary";
    input: typeof AddSymbolToWatchlistRequestSchema;
    output: typeof AddSymbolToWatchlistResponseSchema;
  },
  /**
   * RemoveTickerFromWatchlist removes a ticker from a watchlist
   *
   * @generated from rpc journal.api.v1.WatchlistService.RemoveTickerFromWatchlist
   */
  removeTickerFromWatchlist: {
    methodKind: "unary";
    input: typeof RemoveTickerFromWatchlistRequestSchema;
    output: typeof RemoveTickerFromWatchlistResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_watchlist_service, 0);

